<template>
  <v-col cols="12" :sm="device.isTablet ? 12 : 3">
    <v-row v-if="selectedMenu">
      <category-menu-select-date
        v-if="!device.isDesktop"
        :selected-date="selectedDate"
        @subOneDay="$emit('change-day', -1)"
        :title="device.isTablet ? '' : $t('pages.category_menu.sentence_1_0')"
        @addOneDay="$emit('change-day', 1)"
      ></category-menu-select-date>
      <v-col cols="12">
        <div v-if="device.isDesktop" class="card-section py-4 text-center">
          {{ $t("pages.category_menu.sentence_3") }}
        </div>
        <shift-box
          v-model="model"
          :selectedMenu="selectedMenu"
          :shiftEnable="activeShiftKey"
        ></shift-box>
      </v-col>
      <v-col cols="12" v-if="selectedShiftKey && device.isDesktop">
        <v-row>
          <v-col
            v-for="(item, key) in Object.keys(selectedMenu[selectedShiftKey])"
            :key="key"
            cols="12"
            class="py-1"
          >
            <v-sheet
              :color="selectedCategory != item ? 'rgba(0, 0, 0, 0.02)' : 'primary'"
              :class="selectedCategory != item ? 'black--text' : 'white--text'"
              class="px-2 py-3"
              @click="$emit('select-category', item)"
              style="border-radius: 8px; cursor: pointer"
            >
              {{ toLatin(item) }}
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ShiftBox from "@/components/categoryMenu/shiftBox";
import CategoryMenuSelectDate from "@/components/categoryMenu/CategoryMenuSelectDate.vue";
import hasModel from "@/mixins/hasModel";

export default {
  name: "CategoryMenuGroupSidebar",
  mixins: [hasModel],
  components: {
    ShiftBox,
    CategoryMenuSelectDate,
  },
  props: {
    selectedMenu: {
      type: Object,
      default: null,
    },
    selectedDate: {
      type: String,
      required: true,
    },
    selectedShiftKey: {
      type: String,
      default: null,
    },
    selectedCategory: {
      type: String,
      default: null,
    },
    activeShiftKey: {
      type: String,
      default: "all",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.card-section {
  border: 1px solid #0000001a;
  background-color: rgba($primary-color, 0.05);
  border-radius: 8px 8px 0 0;
}
</style>
